import { render, staticRenderFns } from "./VPopover.vue?vue&type=template&id=20410288"
import script from "./VPopover.vue?vue&type=script&lang=ts"
export * from "./VPopover.vue?vue&type=script&lang=ts"
import style0 from "./VPopover.vue?vue&type=style&index=0&id=20410288&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports